function cvIngredientRail(root) {
  var rail = root.querySelector('.zing__rail');
  var prev = root.querySelector('[data-zing-prev]');
  var next = root.querySelector('[data-zing-next]');
  if (!rail) return;

  function step() {
    var first = rail.querySelector('.zing__item');
    if (!first) return rail.clientWidth;
    /* One card plus the gap, so a click lands cleanly on the next snap point. */
    var styles = window.getComputedStyle(rail);
    return first.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
  }

  function sync() {
    if (!prev || !next) return;
    var max = rail.scrollWidth - rail.clientWidth;
    /* 2px of slack: sub-pixel widths mean scrollLeft rarely hits max exactly. */
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max - 2;
  }

  if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

  rail.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
}  (function () {
    class RvxReviewMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.rvx-rv__track');
        this.group = this.querySelector('.rvx-rv__group');
        if (!this.track || !this.group) return;
        this.baseHTML = this.group.innerHTML;
        this.speed = parseFloat(this.dataset.speed) || 60;
        this.gap = parseFloat(this.dataset.gap) || 0;

        this.rebuild = this.debounce(() => this.build(), 150);

        // Build straight away. Cell widths come from Liquid, so the track can be
        // measured with nothing downloaded -- which is the whole point: the images
        // to the right of a phone screen are lazy and may never load on their own,
        // and waiting on them used to leave the marquee sitting still forever.
        requestAnimationFrame(() => this.build());

        // Images only ever refine the measurement; they never gate it.
        this.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.rebuild, { once: true });
        });

        window.addEventListener('resize', this.rebuild);
      }

      build() {
        // Reset to base state
        Array.from(this.track.querySelectorAll('.rvx-rv__group')).forEach((g, i) => { if (i > 0) g.remove(); });
        this.group.innerHTML = this.baseHTML;

        const container = this.clientWidth || window.innerWidth;
        const base = Array.from(this.group.children);
        if (base.length === 0) return;

        // Clone the base set until one group is at least as wide as the viewport
        let guard = 0;
        while (this.group.scrollWidth < container + 1 && guard < 60) {
          base.forEach((node) => this.group.appendChild(node.cloneNode(true)));
          guard++;
        }

        const groupWidth = this.group.scrollWidth;
        if (!groupWidth) return;

        // One repeat period = group content + the gap that separates the two groups
        const shift = groupWidth + this.gap;

        // Duplicate the group so the track holds two identical halves
        const clone = this.group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        // A clone of a lazy image that sits off to the right may never be asked
        // for, so let the browser fetch these with the rest of the page.
        clone.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
        this.track.appendChild(clone);

        this.track.style.setProperty('--rvx-shift', shift + 'px');
        this.track.style.animationDuration = (shift / this.speed) + 's';
        this.track.classList.add('is-anim');
      }

      debounce(fn, wait) {
        let t;
        return () => { clearTimeout(t); t = setTimeout(fn, wait); };
      }
    }

    if (!customElements.get('review-marquee')) customElements.define('review-marquee', RvxReviewMarquee);
  })();
/* Sivena clone kit — scoped to .cv sections. Keep this file name neutral. */
(function () {
  'use strict';

  var BRAND = '#095946';          /* competitor primary (deep green) */

  /* ---------- scroll target: the offer / bundle tiers ---------- */
  function offerEl() {
    return document.getElementById('cv-offer')
      || document.querySelector('.lumin-product-block-qty-break')
      || document.querySelector('[class*="quantity-break"]')
      || document.querySelector('.product-form__submit, .lumin-submit');
  }
  function toOffer(e) {
    var t = offerEl();
    if (!t) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }
  window.cvToOffer = toOffer;

  /* ---------- every CTA inside a cloned section goes to the offer ---------- */
  function wireCtas() {
    document.querySelectorAll('.cv a[href], .cv button:not([data-cv-skip])').forEach(function (el) {
      if (el.dataset.cvWired) return;
      /* never hijack the page's own controls */
      if (el.closest('details, summary, [data-zing-prev], [data-zing-next], .cv-no-wire')) return;
      if (el.hasAttribute('data-zing-prev') || el.hasAttribute('data-zing-next')) return;
      if (el.tagName === 'A') {
        var h = el.getAttribute('href') || '';
        if (h.charAt(0) === '#' && h !== '#') return;        /* real in-page anchor */
        if (/^(mailto:|tel:)/i.test(h)) return;
      }
      el.dataset.cvWired = '1';
      el.addEventListener('click', toOffer);
    });
  }

  /* ---------- sticky CTA: shown whenever the offer is off-screen ---------- */
  function sticky() {
    var bar = document.getElementById('cv-sticky');
    if (!bar) return;
    function tick() {
      var t = offerEl(), show = false;
      if (t) {
        var r = t.getBoundingClientRect();
        show = r.bottom < 0 || r.top > window.innerHeight;
      }
      /* never cover the cart drawer or its checkout button */
      if (document.querySelector('cart-drawer.active, .cart-drawer.active, .drawer.active, body.overflow-hidden')) show = false;
      bar.style.visibility = show ? 'visible' : 'hidden';
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    setInterval(tick, 500);
  }

  /* ---------- brand colour on the buy controls ----------
     the theme paints these from an ID-level !important rule, which outranks any
     stylesheet rule we can add; inline !important is the only thing that wins. */
  function paintButtons() {
    document.querySelectorAll(
      '.product-form__submit, .lumin-submit, .sticky-atc-button,' +
      ' .shopify-payment-button__button, .cart__checkout-button, button[name="checkout"]'
    ).forEach(function (b) {
      b.style.setProperty('background', BRAND, 'important');
      b.style.setProperty('background-image', 'none', 'important');
      b.style.setProperty('border-color', BRAND, 'important');
      b.style.setProperty('color', '#ffffff', 'important');
      b.style.setProperty('--product-accent', BRAND, 'important');
      b.style.setProperty('--product-accent-contrast', '#ffffff', 'important');
      b.querySelectorAll('*').forEach(function (k) {
        k.style.setProperty('color', '#ffffff', 'important');
      });
    });
  }

  /* ---------- anything the clone left at opacity:0 must still be visible ---------- */
  function reveals() {
    document.querySelectorAll('.cv [class*="animate--"], .cv .scroll-trigger, .cv .fade-out').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  function init() {
    paintButtons();
    wireCtas();
    reveals();
    sticky();
    document.querySelectorAll('.cv [class*="zing"]').forEach(function (el) {
      var root = el.closest('.shopify-section') || el.parentElement;
      if (root && !root.dataset.cvRail) { root.dataset.cvRail = '1'; try { cvIngredientRail(root); } catch (e) { } }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(paintButtons).observe(document.documentElement, { childList: true, subtree: true });
})();
